<template>
	<div class='direction'>
		<div class="banner">
			<img
				@click="onbanner(v)"
				v-for="(v,i) in bannerArr"
				:key="i"
				:src="v.src"
				alt=""
			>
		</div>

		<div
			class="popup"
			:class="{center:center}"
			@click="showPopup = false"
			v-if="showPopup"
		>

			<img
				:src="v"
				v-for="(v,i) in imgList"
				:key="i"
				alt=""
			>

		</div>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  name: "direction",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      bannerArr: [
        {
          src: require("@/assets/banner/banner1.png"),
          imgList: [
            require("@/assets/banner/banner1-1.png"),
            require("@/assets/banner/banner1-2.png"),
            require("@/assets/banner/banner1-3.png"),
            require("@/assets/banner/banner1-4.png"),
          ],
        },
        {
          center: true,
          src: require("@/assets/banner/banner2.png"),
          imgList: [require("@/assets/banner/banner4-5.png")],
        },
        {
          center: true,
          src: require("@/assets/banner/banner3.png"),
          imgList: [require("@/assets/banner/banner4-4.png")],
        },
        {
          src: require("@/assets/banner/banner4.png"),
          imgList: [
            require("@/assets/banner/banner4-1.png"),
            require("@/assets/banner/banner4-2.png"),
            require("@/assets/banner/banner4-3.png"),
            require("@/assets/banner/banner4-4.png"),
            require("@/assets/banner/banner4-5.png"),
            require("@/assets/banner/banner4-6.png"),
            require("@/assets/banner/banner4-7.png"),
          ],
        },
      ],
      showPopup: false,
      center: false,
      imgList: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onbanner(v) {
      this.center = v.center || false;
      this.showPopup = true;
      this.imgList = v.imgList;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
.direction {
  position: absolute;
  right: -320px;

  .banner {
    display: flex;
    flex-direction: column;
    gap: 20px;
    img {
      cursor: pointer;
      width: 300px;
    }
  }

  .popup {
    position: fixed;
    top: 0;
    box-sizing: border-box;
    overflow: auto;
    left: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    z-index: 20;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);

    img {
      width: 70%;
    }
  }

  .center {
    justify-content: center;
  }
}
</style>